// Small analytics wrapper for GA4 with Consent Mode v2.
export const GA_ID = "G-F3B9VM3SHH";
const CONSENT_KEY = "cs_consent";

function gtag(...args) {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(args);
}

export function getConsent() {
  if (typeof window === "undefined") return null;
  try {
    return localStorage.getItem(CONSENT_KEY);
  } catch {
    return null;
  }
}

export function setConsent(value) {
  try {
    localStorage.setItem(CONSENT_KEY, value);
  } catch {
    // noop
  }
  if (value === "granted") {
    gtag("consent", "update", {
      analytics_storage: "granted",
    });
  } else {
    gtag("consent", "update", {
      analytics_storage: "denied",
    });
  }
}

export function trackPageView(path, title) {
  gtag("event", "page_view", {
    page_path: path,
    page_title: title || document.title,
    page_location: window.location.href,
  });
}

export function trackEvent(name, params = {}) {
  gtag("event", name, params);
}

// Convenience conversion events
export function trackBookingClick(source) {
  trackEvent("click_book", {
    event_category: "conversion",
    event_label: source,
    source,
  });
}

export function trackWhatsappClick(source) {
  trackEvent("click_whatsapp", {
    event_category: "conversion",
    event_label: source,
    source,
  });
}

export function trackEmailClick(source) {
  trackEvent("click_email", {
    event_category: "conversion",
    event_label: source,
    source,
  });
}
